export * from './createPDF';

export function getQueryVariable(variable: string): string | null {
    const query: string = window.location.search.substring(1);

    const vars: string[] = query.split('&');

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] === variable) return pair[1];
    }

    return null;
}

// 姓名脱敏
export function hideInsurantName(val: string) {
    if (!val || val === '') return '';
    let name = val;
    if (val.length === 2) {
        name = val.substring(0, 1) + '*'; // 截取name 字符串截取第一个字符，
    } else if (val.length === 3) {
        name = val.substring(0, 1) + '*' + val.substring(2, 3); // 截取第一个和第三个字符
    } else if (val.length === 4) {
        name = val.substring(0, 2) + '*' + '*'; // 4个字隐藏后面两个
    } else if (val.length > 4) {
        name = val.substring(0, 1); // 5个字只显示第一个字
        for (let i = 0; i < val.length - 1; i++) {
            name = name + '*';
        }
    }
    return name;
}

// 手机号脱敏
export function judgePhone(val: string) {
    if (!val) return '';
    const reg = /^(.{3}).*(.{4})$/;
    return val.replace(reg, '$1****$2');
}

// 身份证号脱敏
export function judgeCard(val: string) {
    if (!val) return '';
    const reg = /^(.{3}).*(.{2})$/;
    return val.replace(reg, '$1*************$2');
}

// 数据脱敏
export function judgeFiled(fromData: any[], data: Record<string, any>) {
    fromData.forEach(({ schema }) =>
        schema.forEach(({ filed, showFiled, format }: any) => {
            if (data[filed] && showFiled && format) data[showFiled] = format(data[filed]);
        })
    );
    return data;
}
// 数据加密
export function passWordFiled(fromData: any[], param: Record<string, any>) {
    const data = JSON.parse(JSON.stringify(param));
    fromData.forEach(({ schema }) =>
        schema.forEach(({ filed, showFiled, format }: any) => {
            showFiled && delete data[showFiled];
            if (data[filed] && showFiled && format) {
                data[filed] = window.btoa(unescape(encodeURIComponent(data[filed])));
            }
        })
    );
    return data;
}
// 数据解密
export function unPassWordFiled(fromData: any[], param: Record<string, any>) {
    const data = JSON.parse(JSON.stringify(param));
    fromData.forEach(({ schema }) =>
        schema.forEach(({ filed, showFiled, format }: any) => {
            if (data[filed] && showFiled && format) {
                try {
                    data[filed] = decodeURIComponent(escape(window.atob(data[filed])));
                } catch (error) {}
            }
        })
    );
    return data;
}

export function utf8_to_b64(str: string) {
    return window.btoa(unescape(encodeURIComponent(str)));
}

export function b64_to_utf8(str: string) {
    try {
        return decodeURIComponent(escape(window.atob(str)));
    } catch (error) {
        return str;
    }
}
